import React from "react";
import { useState } from "react";

const CreateAdmin = ({ open, link, fetchData }) => {
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setError(false);
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError(false);

    try {
      const response = await fetch(`${link}/admin/register`, {
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        method: "POST",
      });

      const responseData = await response.json();

      if (response.ok) {
        fetchData && fetchData();
        open(false);
      } else {
        setError(responseData.message || "something went wrong");
      }
    } catch (error) {
      setError("Something Went Wrong");
    }
  };

  return (
    <div>
      <div className="popup-form">
        <div className="popup-form-main">
          <div className="popup-form-heading">Create Admin</div>
          <form onSubmit={handleSubmit}>
            <label>Email :</label>
            <input required onChange={handleChange} type="email" name="email" />

            <label>Password :</label>
            <input
              required
              onChange={handleChange}
              type="text"
              name="password"
            />

            {error ? <div className="popup-form-error">{error}</div> : ""}

            <div className="popup-form-buttons">
              <div onClick={() => open(false)}>Cancel</div>
              <button>Create</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateAdmin;
